import TopSection from "../../LT/TopSection";

const Reporting = () => {
    return (
        <div>
            <TopSection
                labelList={[
                            { title: "Home", path: "/dashboard" },
                    { title: "Reporting" },
                ]}
                tabTitle="Reporting"
            />
        </div>
    )
}

export default Reporting;